import { render, staticRenderFns } from "./OauthCodeReceiver.vue?vue&type=template&id=5c9400f9&"
import script from "./OauthCodeReceiver.vue?vue&type=script&lang=ts&"
export * from "./OauthCodeReceiver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports